import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { updateRetryTimerSecondsLeft } from 'entities/preApprovals/model/preApprovals.slice';

import { CONFIRMATION_STATUS_CODES, DEFAULT_TIMER_SECONDS } from './constants';

export const useApplyTimerFromConfirmationResponse = () => {
  const dispatch = useDispatch();

  return useCallback(
    (res: { statusCode: number; retryAfterInSeconds?: number }) => {
      if (res.statusCode === CONFIRMATION_STATUS_CODES.SUCCESS) {
        dispatch(updateRetryTimerSecondsLeft(DEFAULT_TIMER_SECONDS));
        return;
      }

      if (typeof res.retryAfterInSeconds === 'number' && Number.isFinite(res.retryAfterInSeconds)) {
        dispatch(updateRetryTimerSecondsLeft(res.retryAfterInSeconds));
      }
    },
    [dispatch],
  );
};
